import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'g10-rostering-single-select-map',
  templateUrl: './rostering-single-select-map.component.html',
  styleUrls: ['./rostering-single-select-map.component.css']
})
export class RosteringSingleSelectMapComponent implements OnInit {

  @Input() _inputContainerClass = '';
  @Input() _label = '';
  @Input() modalTitle = '';
  @Input() inputPlaceHolder = '';
  @Input() public set disable(val: string) {
    if (val) this.srchPlaceholder = '';
  }
  @Input() public set selectedLoc(val:any){
    if (val!== undefined && Object.keys(val).length > 0) this.patchPlaceHolder(val);
  }
  @Output() result = new EventEmitter();

  public popup:boolean = true;
  public closePopup:boolean = true;
  public srchPlaceholder = '';
  
  constructor(){}
  ngOnInit(): void { }
  
  openModal(){
    this.closePopup = false;
  }
  selectedLocation(e){
    this.patchPlaceHolder(e);
    this.result.emit(e);
  }
  patchPlaceHolder(e){
    if(e && e.title) this.srchPlaceholder = e.title;
    else if(e && e.location && e.location.name) this.srchPlaceholder = e.location.name;
  }
  closeModal(){
    this.closePopup = true;
  }
}
